// extracted by mini-css-extract-plugin
export default {"uploader":"PhotoUploader_uploader__XlaEI","round-button":"PhotoUploader_round-button__rmsmT"};